import styled from '@emotion/styled';

import breakpoints from 'app/styles/constants/breakpoints';
import { endDirection, startDirection } from 'app/styles/selectors/markup';

const { widthSmall, widthMedium } = breakpoints;

const MegaFanPerks = styled.div`
  label: MegaFanPerks;

  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  margin-top: 1.5rem;

  @media (${widthSmall}) {
    margin-top: 2.5rem;
  }
`;

const Title = styled.h2`
  label: Title;

  margin-${endDirection}: 1.25rem;
  margin-${startDirection}: 1.25rem;

  @media (${widthSmall}) {
    font-size: 1.375rem;
    font-weight: 600;
  }

  @media (${widthMedium}) {
    font-size: 1.5rem;
    line-height: 2rem;
  }
`;

export const Styled = { MegaFanPerks, Title };
